import { OfferModel } from '@/modules/shop/models/offerModels';

export const getSubComissionString = (
  offer: OfferModel,
  showCashbackCap?: boolean
) => {
  const cashbackCap =
    showCashbackCap && offer.cashbackCapDescription
      ? `${offer.cashbackCapDescription}`
      : '';

  return cashbackCap;
};
